export const az = {
    "TRIGGER_LISTEN": "Tetikləri dinləyir",
    "ASSIST_EMPTY_MSG": "Agent AI söhbətinizi aktiv şəkildə dinləyir və tetiklənəndə avtomatik kömək etməyə hazırdır.",
    "MYBOT_TRIGGET_LISTEN": "Hazırda aktiv My Bot tapşırıqları yoxdur",
    "MYBOT_EMTPY_MSG": "My Bot-da bir tapşırığı başlatmaq üçün axtarış sekmesine keçin və istədiyiniz tapşırıq üçün \"Agent girişləri ilə icra et\" seçimini seçin.",
    "PROACTIVE_MODE": "Proaktiv Mod",
    "SETTINGS": "Ayarlar",
    "HELP_AND_SUPPORT": "Kömək və Dəstək",
    "HELP": "Kömək",
    "LANGUAGE": "Dil",
    "THEME": "Tema",
    "AUTOMATIC": "Avtomatik",
    "DARK": "Qaranlıq",
    "AUTO_SCROLL_TOOLTIP":"Yardım nişanı, Mənim Botlarım və Transkript tabları məzmunun avtomatik sürüşməsinə nəzarət edir",
    "LIGHT": "Aydın",
    "TAP_SEARCH":"Axtarış üçün toxunun",
    "THEME_DESC": "Bu sistemin standart modunu istifadə edəcəkdir",
    "DOCUMENTATION": "Sənədləşdirmə",
    "DOC_DESC": "Dərin sənədləşdirmə məqalələrimizi yoxlayın.",
    "FAQ_U": "Tez-tez verilən suallar",
    "FAQ_DESC": "Agent AI ilə bağlı tez-tez verilən sualları yoxlayın.",
    "KORE_ACADEMY": "Kore Akademiyası",
    "KORE_ACA_DESC": "Agent AI haqqında daha çox öyrənmək üçün akademiya kurslarını keçin.",
    "SEARCH": "Axtarış",
    "MY_BOT": "Mənim Botum",
    "ASSIST": "Kömək",
    "TRANSCRIPT": "Transkript",
    "HISTORY": "Tarix",
    "STARTOVER": "Yenidən başlayın",
    "RESTART_INPUTS": "Tutulan girişlərlə yenidən başlayın",
    "ASKCUSTOMER": "Müştəriyə soruşun",
    "TELLCUSTOMER": "Müştəriyə bildirin",
    "WELCOME_MSG": "Xoş gəlmisiniz mesajı",
    "SEND": "Göndər",
    "SENT": "Göndərildi",
    "AWAITING": "Cavab gözləyir | Davam etmək üçün yazın",
    "OVERRIDE": "Davam etmək üçün yazın",
    "OVERRIDE_FILE": "Davam etmək üçün fayl əlavə edin",
    "ACCEPT_RESPONSE": "Cavab qəbul edildi",
    "AGENT_ENTERED": "Agent daxil oldu",
    "EXPECTED_FORMAT": "Gözlənilən Format",
    "INPUT_VALUES": "Giriş Dəyərləri",
    "RESTART": "Yenidən başlayın",
    "START_OVER": "Yenidən başlayın",
    "RESTART_CAPTURE": "Tutulan girişlərlə yenidən başlayın",
    "CANCEL": "Ləğv et",
    "INTERRUPT_DIALOG": "DİALOG TAPŞIRIQI DAYANDIRILDI",
    "RUN": "İCRAA ET",
    "RUN_AGENT": "Agentin girişi ilə icra et",
    "STEP": "Addım",
    "DIALOG_TASK": "Dialoq Tapşırığı",
    "FAQ": "Tez-tez verilən suallar",
    "SNIPPET": "Cavablar",
    "ARTICLE": "Veb Səhifələr",
    "FILE": "Fayllar",
    "SUGGESTED": "Təklif olunan",
    "ALL_DIALOG": "Bütün Dialoq Tapşırıqları",
    "DIALOG_TEXT": "Dialoq",
    "INTENT_IDENTIFIED": "Müştəri ifadəsi",
    "NOT_WHAT_LOOKING": "Yanlış təklif?",
    "BOT": "Bot",
    "CUSTOMER": "Müştəri",
    "YOU": "Sən",
    "TERMINATE_CONV": "Dialoq Tapşırığını Sonlandır",
    "TERMINATE_CONV_DESC": "Dialoq tapşırığını sonlandırmaq istədiyinizə əminsiniz? Agent AI artıq təkliflər edə bilməyəcək.",
    "YES_TERMINATE": "Bəli, Sonlandır",
    "NO_CANCEL": "Xeyr, Ləğv et",
    "OVERRIDE_CONTINUE": "Üstünlük modunda davam et",
    "SUMMARY_TEXT": "Xülasə",
    "SUBMIT": "Göndər",
    "INTERRUPT_OCCURED": "İnterrupt baş verdi",
    "IDENTIFIED_INTENT": "Müəyyən edilmiş niyyət",
    "INTERRUPT_DESC": "Bunun icrası sizin davam edən dialoq tapşırığınızı dayandıracaq.",
    "ACCEPT_RUN": "Qəbul et və İcra et",
    "RUN_LATER": "Sonra İcra et",
    "KNOW_MORE": "Daha çox məlumat",
    "MORE_TEXT": "Daha çox",
    "LESS_TEXT": "Az",
    "VIEW_MORE": "Daha çox bax",
    "VIEW_LESS": "Daha az bax",
    "SHOW_MORE_FAQ": "Daha çox tez-tez verilən sualları göstər",
    "SHOW_LESS_FAQ": "Daha az tez-tez verilən sualları göstər",
    "SHOW_MORE_ARTICLE": "Daha çox veb səhifəni göstər",
    "SHOW_LESS_ARTICLE": "Daha az veb səhifəni göstər",
    "SHOW_MORE_SNIPPET": "Daha çox cavabları göstər",
    "SHOW_LESS_SNIPPET": "Daha az cavabları göstər",
    "SHOW_MORE_FILES": "Daha çox fayl göstər",
    "SHOW_LESS_FILES": "Daha az fayl göstər",
    "VIEW_ALL_DIALOG": "Bütün Dialoqları Gör",
    "VIEW_FEW_DIALOG": "Bir neçə Dialoqları Gör",
    "HELP_FULL": "Faydalı mı?",
    "THANKYOU": "Təşəkkür edirəm!",
    "EXPAND_MORE": "Genişləndir / Daha çox",
    "CLOSE_TEXT": "Bağla",
    "STARTED": "Başladı",
    "ENDED": "Bitdi",
    "VIEW_FULL_ARTICLE": "Veb səhifəni göstər",
    "VIEW_FULL_FILE": "Faylı göstər",
    "COPIED": "Kopyalandı",
    "SENTI_ANALY": "Hisslərin Analizi",
    "WRONG_SUGGESTION": "Yanlış təklif",
    "INCORRECT_INTENT": "Yanlış niyyət",
    "ACCIDENTAL_CLICK": "Təsadüfi klik",
    "PLAYBOOK": "Oyun kitabı",
    "TIME_TAKING": "Zaman alıcı",
    "OTHER": "Digər",
    "PLAYBOOK_EMPTY_MSG": "Playbook seçin",
    "PLAYBOOK_EMPTY_DESC": "Agent AI bütün mövcud playbookların dinamik olması səbəbindən playbooku yükləyə bilmir. 'Playbook seçin' düyməsinə basın.",
    "STAGE": "Səhnə",
    "PROCEED_TO_CLOSE": "Bağlamağa davam et",
    "RECOMENDED_PLAYBOOK": "TÖVSİYƏ OLUNAN PLAYBOOK",
    "PRIMARY_SCRIPTS": "ƏSAS SİKRIYTLƏR",
    "DYNAMIC_SCRIPTS": "DINAMIK SİKRIYTLƏR",
    "RESUME": "Davamedin",
    "ENABLE_CLOSE": "Bağlama mərhələsini aktivləşdirmək üçün davam et düyməsini basın",
    "LIST_VIEW": "Siyahı Görünüşü",
    "TERMINATE": "Sonlandır",
    "MINIMIZE": "Kiçilt",
    "MAXIMIZE": "Böyüt",
    "NO_SEARCH_RESULT": "Axtarış nəticəsi tapılmadı",
    "SENTIMENT_AWAITING": "Hisslərin gözlənilməsi",
    "POSITIVE": "Müsbət",
    "FILE_NAME":"Fayl adı",
    "NEGATIVE": "Mənfi",
    "VIEW_FULL_ARTICLE_2": "Tam məqaləyə bax",
    "VIEW_FULL_FILE_2": "Tam fayla bax",
    "TAB_TEXT":"Heç bir sekme aktiv deyil! Zəhmət olmasa, ən azı bir sekmeni aktiv edin",
    "ASSOCIATED_WORK_NOTES": "Keçmiş Həll Notları",
    "AGENT_JOINED_CONV": "Agent söhbətə qoşuldu",
    "AUTOSCROLL_ASSIST": "Avtomatik Sürüşmə Dəstək Sekmesi Məzmunu",
    "FILE_SIZE_MSG": "Fayl ölçüsü 25MB daxilində olmalıdır. Yenidən cəhd edin.",
    "OVERRIDE_BTN": "Üstünlük",
    "CHOOSE_FILE": "Fayl Seç",
    "SUMMARY_ERROR_TEXT": "Bağışlayın, amma bu söhbət üçün xülasə yaratmaqda problem oldu. Öz xülasənizi yaradın, zəhmət olmasa",
    "ASK_A_QUESTION": "Sualları soruşun",
    "COPY": "Kopyala",
    "TELL_US_MORE": "Daha çox məlumat verin…",
    "THANKS_FEEDBACK": "Rəyiniz üçün təşəkkürlər",
    "SOMETHING_WRONG": "Nəsə səhv getdi",
    "CLICK_ERROR_DETAILS": "Xəta detalları üçün klikləyin",
    "NO_ACTIVE_PLAYBOOK": "Aktiv oyun kitabçası yoxdur",
    "REPHRASE_QUESTION": "Sualınızı yenidən ifadə edə bilərsinizmi, yoxsa başqa bir şey soruşmaq istəyirsiniz?",
    "INTERNAL_INFO": "Daxili məlumat",
    "SOURCES": "Mənbələr",
    "CONVERSATION_SUMMARY": "Söhbətin xülasəsi",
    "WAITING": "Gözlənilir",
    "WIDGET_DISABLED": "Widget deaktiv edilib",
    "AI_SETTINGS_DISABLED": "AI parametrləri deaktiv edilib! Zəhmət olmasa AI administratoru ilə əlaqə saxlayın",
    "SERVER_CONNECTION_ERROR": "Serverə qoşulmada xəta baş verdi",
    "VIEW": "Bax",
    "ATTACHMENT_INPUT": "Qoşma girişi",
    "TYPE_SUMMARY": "Xülasə yaz",
    "BY":"Tərəfindən",
    GENERATE_SUMMARY: "Xülasə yarat",
    PREV_SUMMARIES: "Əvvəl yaradılan xülasələr",
    DIALOG_WORKFLOWS: "Dialoq İş Axınları",
    SHOW_ALL_DIALOG: "Bütün Dialoq Tapşırıqlarını Göstər",
    SHOW_ALL_DIALOGS: "Bütün Dialoqları Göstər",
    CUSTOM_TAB: "Xüsusi Tab",
    AGENT_INPUT: "Agentin Girişi",
    "CUSTOM_EMPTY_MSG" : "Aktiv iş axını yoxdur",
    "CUSTOM_TAB_DESC" : "İş axınını başlatmaq üçün, ekranın aşağısında olan siyahıdan birini icra edin.",
    "SUBMIT_OVERALL_FEEDBACK" : "Ümumi Rəy Göndər",
    "FEEDBACK_POPUP_SUBTITLE" : "Widget və onun xüsusiyyətlərinizlə necə mükafatlandığınızı necə qiymətləndirirsiniz?",
    "FEEDBACK_SATISFIED" : "Mükafatlandı",
    "FEEDBACK_UNSATISFIED" : "Mükafatlandırmadı",
    "FEEDBACK_PROVIDE_REASONS" : "Daha çox məlumat verin…",
    "FEEDBACK_TITLE" : "Rəy",
    "AGENTIC_THINKING" : "Düşünür",
    "AGENTIC_AGENT_TITLE" : "Agent",
    "AGENTIC_COPILOT_MODE_TITLE" : "Agentik Copilot Modu",
    "AGENTIC_SENDING_MESSAGE" : "Göndərilir...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot söhbətinizi aktiv şəkildə dinləyir və avtomatik kömək etməyə hazırdır",
    "AGENTIC_SEARCH_RESULTS" : "Agent Nəticələri",
    "PAUSE_AUTO_SEND" : "Avtomatik Göndərməni Dayandır",
    "PAUSE_AGENTIC" : "Agentı Dayandır",
    "RESUME_AGENTIC" : "Agentı Davam Etdir",
    "RESUME_AUTO_SEND" : "Avtomatik Göndərməni Davam Etdir"
}
